var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "_ngcontent-ng-c562630004": "",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "_ngcontent-ng-c562630004": "",
    d: "M10.0001 0C4.48012 0 0.00012207 4.48 0.00012207 10C0.00012207 15.52 4.48012 20 10.0001 20C15.5201 20 20.0001 15.52 20.0001 10C20.0001 4.48 15.5201 0 10.0001 0ZM14.6401 6.8C14.4901 8.38 13.8401 12.22 13.5101 13.99C13.3701 14.74 13.0901 14.99 12.8301 15.02C12.2501 15.07 11.8101 14.64 11.2501 14.27C10.3701 13.69 9.87012 13.33 9.02012 12.77C8.03012 12.12 8.67012 11.76 9.24012 11.18C9.39012 11.03 11.9501 8.7 12.0001 8.49C12.0071 8.45819 12.0061 8.42517 11.9974 8.3938C11.9887 8.36244 11.9725 8.33367 11.9501 8.31C11.8901 8.26 11.8101 8.28 11.7401 8.29C11.6501 8.31 10.2501 9.24 7.52012 11.08C7.12012 11.35 6.76012 11.49 6.44012 11.48C6.08012 11.47 5.40012 11.28 4.89012 11.11C4.26012 10.91 3.77012 10.8 3.81012 10.45C3.83012 10.27 4.08012 10.09 4.55012 9.9C7.47012 8.63 9.41012 7.79 10.3801 7.39C13.1601 6.23 13.7301 6.03 14.1101 6.03C14.1901 6.03 14.3801 6.05 14.5001 6.15C14.6001 6.23 14.6301 6.34 14.6401 6.42C14.6301 6.48 14.6501 6.66 14.6401 6.8Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelegram);
export default __webpack_public_path__ + "static/media/icon-telegram.36cf594261d1a686ca4240299efe94ac.svg";
export { ForwardRef as ReactComponent };